<template lang="pug">
  #home
    Map
    //Options
    Grid
</template>

<script>
// @ is an alias to /src
import Map from "@/components/Map.vue";
import Grid from "@/components/Grid.vue";
import Options from "@/components/Options.vue";
import Tooltip from "@/components/Tooltip.vue";
import PostCard from "@/components/postcard/PostCard.vue";

export default {
  name: "home",
  components: {
    Tooltip,
    Options,
    Grid,
    Map,
    PostCard
  }
};
</script>
